import { Document } from '@contentful/rich-text-types';
import { Heading, Image, TextPassage } from '@petsmart-ui/sparky';
import { type Asset } from 'contentful';

import { clsx } from '@libs/common-next';
import { parseRichText } from '@libs/contentful';

import { VetRxEntry } from '@/entities/vet-rx-content';
import { BaseDrawer } from '@/shared/ui';

import { getVetRxDrawerData } from '../lib';
import type { VetRxDrawerTypes } from './types';

import './VetRxDrawer.scss';

type VetRxDrawerProps = {
    open: boolean;
    onCloseAction: () => void;
    vetRx: VetRxEntry[];
    type?: VetRxDrawerTypes;
};

export const VetRxDrawer = ({ open, vetRx, type, onCloseAction }: VetRxDrawerProps) => {
    const { title, bodyHeading, body } = getVetRxDrawerData(vetRx ?? [], type);

    const vetRxBody = (
        <div className="vet-rx__rich-text">
            {bodyHeading ? (
                <Heading id="drawer-heading" tagName="h2">
                    {bodyHeading}
                </Heading>
            ) : null}
            {body.map((item, index) => (
                <div key={item.fields?.title}>
                    {item.fields?.image ? (
                        <Image
                            data-testid="vet-rx-image"
                            className={clsx('vet-rx__drawer-img', index === 0 && 'vet-rx__drawer-img--first')}
                            src={(item.fields?.image as Asset)?.fields?.file?.url as string}
                            alt={(item.fields?.image as Asset)?.fields?.title as string}
                        />
                    ) : null}
                    <TextPassage className="vet-rx__subtitle" size="lg">
                        {item.fields?.subtitle as string}
                    </TextPassage>
                    <TextPassage>{parseRichText(item.fields?.content as Document)}</TextPassage>
                </div>
            ))}
        </div>
    );
    return (
        <BaseDrawer isOpen={open} title={title} onCloseAction={onCloseAction} testId="specialty-info-drawer">
            {vetRxBody}
        </BaseDrawer>
    );
};
